var path = '/home/jenkins/workspace/arcade_Arcade-UI_release/app/views/ui/pagination.html';
var html = "<div ng-transclude></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
export default  path;